var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagicpenRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "magicpen"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.0042 13.5841C20.5028 13.7402 19.9624 13.9623 19.4294 14.278C18.2134 14.9983 17.082 16.1805 16.5169 18.0568C15.9528 16.1706 14.8198 14.9859 13.6004 14.2666C13.0628 13.9494 12.5177 13.7278 12.0127 13.5732C12.5058 13.4193 13.0363 13.2014 13.5601 12.8931C14.7818 12.1741 15.9201 10.9893 16.4867 9.10157C17.0536 10.9895 18.1928 12.1745 19.4175 12.8935C19.9547 13.209 20.4993 13.4297 21.0042 13.5841Z",
    fill: "#E64E2C",
    stroke: "#E64E2C",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.59478 5.97969C8.85688 6.41338 8.17877 7.14936 7.89239 8.34454C7.61254 7.13372 6.9354 6.38917 6.19375 5.95136C5.7983 5.71792 5.39572 5.57799 5.04641 5.49423C5.39201 5.4102 5.79022 5.27097 6.18212 5.04064C6.93628 4.5974 7.62798 3.8384 7.90286 2.59614C8.17774 3.8384 8.86944 4.5974 9.6236 5.04064C10.0359 5.28294 10.4551 5.42442 10.8127 5.50689C10.4489 5.58835 10.0182 5.73086 9.59478 5.97969Z",
    fill: "#E64E2C",
    stroke: "#E64E2C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M2.88125 18.9494C2.4858 18.716 2.08321 18.576 1.73391 18.4923C2.07951 18.4082 2.47771 18.269 2.86962 18.0387C3.62378 17.5954 4.31548 16.8364 4.59036 15.5942C4.86524 16.8364 5.55694 17.5954 6.3111 18.0387C6.72337 18.281 7.14261 18.4225 7.50025 18.5049C7.13643 18.5864 6.70568 18.7289 6.28228 18.9777C5.54438 19.4114 4.86627 20.1474 4.57989 21.3426C4.30004 20.1318 3.6229 19.3872 2.88125 18.9494Z",
    fill: "#E64E2C",
    stroke: "#E64E2C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagicpenRed);
export default __webpack_public_path__ + "static/media/magicpenRed.58bc20a036233dd51f9276f64b08b339.svg";
export { ForwardRef as ReactComponent };